import { API_BASE_URL } from '../config/api';
import type {
  PlayerHeatMap
} from '../types/player';
import type {
  CampogramaData,
  TeamPositioning,
  FormationsResponse,
  TacticalTemplatesResponse
} from '../types/tactical';
import type { AuthHeaders } from '../types/common';

class CampogramasService {
  private getAuthHeaders(): AuthHeaders {
    const token = localStorage.getItem('token');
    return {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    };
  }

  async generateCampograma(playersData: any[], formation: string, matchContext: any = {}): Promise<CampogramaData> {
    try {
      const response = await fetch(`${API_BASE_URL}/campogramas/generate`, {
        method: 'POST',
        headers: this.getAuthHeaders(),
        body: JSON.stringify({
          players_data: playersData,
          formation,
          match_context: matchContext
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error generating campograma:', error);
      throw error;
    }
  }

  async generateMatchTacticalAnalysis(matchData: any): Promise<any> {
    try {
      const response = await fetch(`${API_BASE_URL}/campogramas/match-analysis`, {
        method: 'POST',
        headers: this.getAuthHeaders(),
        body: JSON.stringify({
          match_data: matchData
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error generating match tactical analysis:', error);
      throw error;
    }
  }

  async getAvailableFormations(): Promise<FormationsResponse> {
    try {
      const response = await fetch(`${API_BASE_URL}/campogramas/formations`, {
        method: 'GET',
        headers: this.getAuthHeaders()
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error getting formations:', error);
      throw error;
    }
  }

  async getTeamPositioning(teamId: number): Promise<TeamPositioning> {
    try {
      const response = await fetch(`${API_BASE_URL}/campogramas/team/${teamId}/positioning`, {
        method: 'GET',
        headers: this.getAuthHeaders()
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error getting team positioning:', error);
      throw error;
    }
  }

  async getPlayerHeatMap(playerId: number): Promise<PlayerHeatMap> {
    try {
      const response = await fetch(`${API_BASE_URL}/campogramas/player/${playerId}/heat-map`, {
        method: 'GET',
        headers: this.getAuthHeaders()
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error getting player heat map:', error);
      throw error;
    }
  }

  async getTacticalTemplates(): Promise<TacticalTemplatesResponse> {
    try {
      const response = await fetch(`${API_BASE_URL}/campogramas/tactical-templates`, {
        method: 'GET',
        headers: this.getAuthHeaders()
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error getting tactical templates:', error);
      throw error;
    }
  }
}

export const campogramasService = new CampogramasService();
